import React, { useCallback, useState } from "react"
import { VariableSizeList as List } from "react-window"
import "./styles.scss"
import moment from "moment"
import { CustomAvatarGroup } from "../Avatar"
import { PickerWithType } from "../DatePicker"
import { ButtonLoader } from "../Button"
import { exportContentSent } from "../../core/utils/exports"

export const ProducerListItem = ({ item }) => {
  const [open, setOpen] = useState(false)
  // const { exportContent, loading } = exportContentSent(item?.data, item?.beneficiary, `content_sent_${item.beneficiary}`, true)

  const handleOpen = () => {
    setOpen(!open)
  }

  const getRowHeight = (index) => {
    return 50
  }

  const Row = ({ index, style }) => {
    const rowData = item.data[index]

    return (
      <div className="table-row" style={style}>
        <div className="table-cell" title={rowData.content}>
          {rowData.content}
        </div>
        <div className="table-cell">{rowData.technician}</div>
        <div className="table-cell">{moment(rowData?.send_data).format("DD/MM/YYYY")}</div>
        <div className="table-cell">{rowData?.read_data ? moment(rowData?.read_data).format("DD/MM/YYYY") : "Aguardando leitura"}</div>
        <div className="table-cell">{rowData.project}</div>
      </div>
    )
  }

  return (
    <>
      <div className="content-item">
        <div className="row-title" onClick={handleOpen}>
          <i className="fi fi-rr-document"></i>
          <div className="content-text">{item.beneficiary}</div>
          <div className="badges">
            <div className="document-badge">
              <i className="fi fi-rr-document"></i> {item.totalContents}
            </div>
            {open ? (
              <i className="fi fi-sr-angle-small-up" />
            ) : (
              <i className="fi fi-sr-angle-small-down" />
            )}
          </div>
        </div>
        {open && (
          <>
            <div className="table-container">
              <div className="table-header">
                <div className="table-cell">Conteúdo</div>
                <div className="table-cell">Técnico</div>
                <div className="table-cell">Data de Envio</div>
                <div className="table-cell">Data de Leitura</div>
                <div className="table-cell">Projeto</div>
              </div>
              <List
                className="table-body"
                height={300}
                itemCount={item.data.length}
                itemSize={getRowHeight}
                width="100%">
                {Row}
              </List>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export const ContentListItem = ({ item }) => {
  const [open, setOpen] = useState(false)
  // const { exportContent, loading } = exportContentSent(item?.data, item?.content)

  const handleOpen = () => {
    setOpen(!open)
  }

  const getRowHeight = (index) => {
    return 50
  }

  const Row = ({ index, style }) => {

    const rowData = item?.data[index]

    return (
      <div className="table-row" style={style}>
        <div className="table-cell" title={rowData?.beneficiary}>
          {rowData?.beneficiary}
        </div>
        <div className="table-cell">{rowData?.technician}</div>
        <div className="table-cell">{moment(rowData?.send_data).format("DD/MM/YYYY")}</div>
        <div className="table-cell">
          {rowData?.read_data ? moment(rowData?.read_data).format("DD/MM/YYYY") : "Aguardando leitura"}
        </div>
        <div className="table-cell">{rowData?.project}</div>
      </div>
    )
  }
  
  return (
    <div className="content-item">
      <div className="row-title" onClick={handleOpen}>
        <i className="fi fi-rr-document"></i>
        <div className="content-text">{item?.content || ""}</div>
        <div className="badges">
          <CustomAvatarGroup users={item?.data} keyAvatarName="beneficiary" maxCount={3} />
          {open ? (
            <i className="fi fi-sr-angle-small-up" />
          ) : (
            <i className="fi fi-sr-angle-small-down" />
          )}
        </div>
      </div>
      {open && (
        <>
          <div className="table-container">
            <div className="table-header">
              <div className="table-cell">Beneficiário</div>
              <div className="table-cell">Técnico</div>
              <div className="table-cell">Data de Envio</div>
              <div className="table-cell">Data de Leitura</div>
              <div className="table-cell">Projeto</div>
            </div>
            <List
              className="table-body"
              height={300}
              itemCount={item?.data.length}
              itemSize={getRowHeight}
              width="100%">
              {Row}
            </List>
          </div>
        </>
      )}
    </div>
  )
}
